"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _ConfirmationDialog = _interopRequireDefault(require("../dialogs/ConfirmationDialog"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var EditTemplate = exports["default"] = /*#__PURE__*/function (_Component) {
  function EditTemplate(props) {
    var _this;
    _classCallCheck(this, EditTemplate);
    _this = _callSuper(this, EditTemplate, [props]);
    _this.state = {
      showNavigateAwayConfirmation: false,
      hasEdit: false,
      detectEdit: true,
      name: null
    };
    return _this;
  }
  _inherits(EditTemplate, _Component);
  return _createClass(EditTemplate, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var detectEdit = this.state.detectEdit;
      if (prevProps.detectEdit !== this.props.detectEdit) this.setState({
        detectEdit: this.props.detectEdit
      });else if (detectEdit) this.detectEdits(this.props.compare);
    }
  }, {
    key: "detectEdits",
    value: function detectEdits(compare) {
      var _this2 = this;
      if (!compare) return false;
      var _this$props = this.props,
        onBlockNavigation = _this$props.onBlockNavigation,
        onEditStateChange = _this$props.onEditStateChange,
        name = _this$props.name;
      var existing = compare.existing,
        editing = compare.editing,
        members = compare.members;
      var hasEdit = false;
      members.forEach(function (member) {
        if (!hasEdit && _this2.detectEdit(existing, editing, member)) {
          hasEdit = true;
        }
      });
      if (this.state.hasEdit !== hasEdit) {
        if (onEditStateChange) onEditStateChange(hasEdit);
        this.setState({
          hasEdit: hasEdit
        });
      }
      if (onBlockNavigation) onBlockNavigation(hasEdit, name, function () {
        return _this2.setState({
          showNavigateAwayConfirmation: true
        });
      });
    }
  }, {
    key: "detectEdit",
    value: function detectEdit(existing, editing, member) {
      if (!editing) return false;
      var existingVal = existing ? existing[member.name] : null;
      var isNew = !existing || existingVal === null || existingVal === undefined;
      var editingVal = editing ? editing[member.name] : null;
      var isCleared = !isNew && (editingVal === null || editingVal === undefined);
      if (member.detectEdit && typeof member.detectEdit === "function") return member.detectEdit(existing, editing, isNew, isCleared);
      if (isNew && (editingVal === null || editingVal === undefined)) return false;

      //Arrays
      if (Array.isArray(existingVal) && Array.isArray(editingVal)) {
        if (existingVal.length === 0 && editingVal.length === 0) return false;
        if (existingVal.length !== editingVal.length) return true;
        if (member.arrayMatch && typeof member.arrayMatch === "function") {
          var _iterator = _createForOfIteratorHelper(existingVal),
            _step;
          try {
            var _loop = function _loop() {
                var i1 = _step.value;
                if (!editingVal.some(function (i2) {
                  return member.arrayMatch(i1, i2);
                })) {
                  return {
                    v: true
                  };
                }
              },
              _ret;
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              _ret = _loop();
              if (_ret) return _ret.v;
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          return false;
        }
      }

      //Dates
      if (existingVal instanceof Date && editingVal instanceof Date) {
        if (member.detectEdit === "compareDay") {
          return !EditTemplate.isSameDay(existingVal, editingVal);
        }
        return existingVal.toString() !== editingVal.toString();
      }
      if (isNew && typeof editingVal === "string") return editingVal && editingVal.length !== 0;
      return editingVal !== existingVal;
    }
  }, {
    key: "onCloseNavigateAwayConfirmation",
    value: function onCloseNavigateAwayConfirmation(e) {
      this.setState({
        showNavigateAwayConfirmation: false
      });
    }
  }, {
    key: "onAcceptNavigateAwayConfirmation",
    value: function onAcceptNavigateAwayConfirmation(e) {
      var onAllowNavigation = this.props.onAllowNavigation;
      if (onAllowNavigation) onAllowNavigation(e);
      this.setState({
        showNavigateAwayConfirmation: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        children = _this$props2.children,
        theme = _this$props2.theme;
      var _this$state = this.state,
        showNavigateAwayConfirmation = _this$state.showNavigateAwayConfirmation,
        hasEdit = _this$state.hasEdit;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, children, hasEdit && /*#__PURE__*/_react["default"].createElement("div", null), showNavigateAwayConfirmation && /*#__PURE__*/_react["default"].createElement(_ConfirmationDialog["default"], {
        title: "Unsaved changes",
        question: "You have unsaved changes that will be lost if you leave this page without saving them. Are you sure you want to leave this page?",
        acceptButton: "Leave page",
        onCancel: this.onCloseNavigateAwayConfirmation.bind(this),
        onAccept: this.onAcceptNavigateAwayConfirmation.bind(this),
        theme: theme
      }));
    }
  }], [{
    key: "isSameDay",
    value: function isSameDay(d1, d2) {
      return d1.getFullYear() === d2.getFullYear() && d1.getDate() === d2.getDate() && d1.getMonth() === d2.getMonth();
    }
  }]);
}(_react.Component);